<template>
  <dialog-modal-fi
    ref="retailerSearchDialog"
    class="retail-search-dialog-fi"
    large-padding
    lazy
    prevent-close-on-click-outside
  >
    <template #header>
      <h2
        v-if="fields.retailerSearchHeadline?.value"
        class="retail-search-dialog-fi__headline"
      >
        {{ fields.retailerSearchHeadline.value }}
      </h2>

      <richtext-fi
        v-if="description"
        class="retail-search-dialog-fi__description"
        :html-content="description"
      />
    </template>

    <template #body>
      <div class="retail-search-dialog-fi__retailer-search">
        <retailer-search-fi
          ref="retailerSearch"
          theme="modal"
          :country-list="countryList[1]"
          :default-country="countryList[2]"
          :ranges="ranges"
          :default-range="defaultRange"
          :product-ids="catalogId"
        />
      </div>
    </template>
  </dialog-modal-fi>
</template>

<script>
import { DialogModalFi, RichtextFi } from 'atoms';
import { defineAsyncComponent } from 'vue';

import distanceMixin from '@/mixins/distanceMixin.vue';
import { getSelectList } from '@/utils/fieldTransformations';

const RetailerSearchFi = defineAsyncComponent(
  () => import('@/components/retailer-search-fi/RetailerSearchFi.vue'),
);

export default {
  name: 'RetailSearchDialogFi',
  components: {
    DialogModalFi,
    RetailerSearchFi,
    RichtextFi,
  },
  mixins: [distanceMixin],
  inject: ['fields'],
  props: {
    catalogId: {
      type: String,
      default: null,
    },
    productName: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      isShown: false,
    };
  },
  computed: {
    countryList() {
      return getSelectList(this.fields, 'countryList', []);
    },
    ranges() {
      const ranges = [];
      if (this.fields.retailerSearchRanges?.value) {
        this.fields.retailerSearchRanges.value.split(',').forEach((range) => {
          ranges.push({ name: `${range} ${this.unit}`, value: range });
        });
      }

      return ranges.length ? ranges : undefined;
    },
    defaultRange() {
      if (this.fields.retailerSearchDefaultRange?.value) {
        return this.fields.retailerSearchDefaultRange.value;
      }

      return undefined;
    },
    description() {
      if (this.fields.retailerSearchDescription?.value) {
        return {
          value: this.fields.retailerSearchDescription.value
            .replace('{0}', Number(this.catalogId))
            .replace('{1}', this.productName),
        };
      }

      return null;
    },
  },
  methods: {
    show() {
      this.$refs.retailerSearchDialog.open();
    },
  },
};
</script>

<style scoped src="./retail-search-dialog-fi" />
